function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19383",
  "data-name": "Group 19383",
  transform: "translate(-552.399 -2049.885)"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-data",
  transform: "translate(535.75 2054.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31652",
  "data-name": "Path 31652",
  d: "M31.5,9h2.25v6.188H31.5Z",
  transform: "translate(0 2.813)",
  fill: "#07519c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31653",
  "data-name": "Path 31653",
  d: "M25.875,5.625h2.25V18h-2.25Z",
  fill: "#07519c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31654",
  "data-name": "Path 31654",
  d: "M20.25,11.25H22.5V18H20.25Z",
  transform: "translate(0 0.281)",
  fill: "#07519c"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_31655",
  "data-name": "Path 31655",
  d: "M27.428,11.25,29,14.207l3.358.408-2.464,2.221.493,3.284-2.957-1.848L24.471,20.12l.493-3.285L22.5,14.614l3.45-.407,1.479-2.957Z",
  transform: "translate(535.322 2038.635)",
  fill: "#07519c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31656",
  "data-name": "Path 31656",
  d: "M26.228,11.25l1.188,2.237,2.541.309-1.864,1.68.373,2.485-2.237-1.4-2.237,1.4.373-2.485L22.5,13.8l2.61-.308,1.119-2.237Z",
  transform: "translate(529.899 2047.067)",
  fill: "#07519c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31657",
  "data-name": "Path 31657",
  d: "M26.228,11.25l1.188,2.237,2.541.309-1.864,1.68.373,2.485-2.237-1.4-2.237,1.4.373-2.485L22.5,13.8l2.61-.308,1.119-2.237Z",
  transform: "translate(542.899 2047.067)",
  fill: "#07519c"
}));

function SvgTargetSkillScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.456,
    height: 22.771,
    viewBox: "0 0 20.456 22.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSkillScore);
export default __webpack_public_path__ + "static/media/target-skill-score.100e4d33.svg";
export { ForwardRef as ReactComponent };